import { render, staticRenderFns } from "./previewGoods.vue?vue&type=template&id=a1a0d130&scoped=true&"
import script from "./previewGoods.vue?vue&type=script&lang=js&"
export * from "./previewGoods.vue?vue&type=script&lang=js&"
import style0 from "./previewGoods.vue?vue&type=style&index=0&id=a1a0d130&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a0d130",
  null
  
)

export default component.exports